import axios from "axios";
import { API_URL } from "../common/constants";
import * as types from "./types";


export const getCartofactWells = async (params) => {
  const url = `${API_URL}/gis/cartofact/wells`;
  try {
    // console.log('Fetching wells:', url, params);
    const response = await axios.post(url, params);

    if (response.data) {
      return response.data;
    } else {
      console.error('Failed to fetch wells', response);
      return [];
    }

  } catch (error) {
    console.error('Error fetching wells:', url, error);
    return [];
  }
};


export const getCompanies = async (params) => {
  const url = `${API_URL}/gis/cartofact/companies`;
  try {
    // console.log('Fetching wells:', url, params);
    const response = await axios.post(url, params);
    console.log('Fetched companies:', response.data);
    if (response.data) {
      return response.data;
    } else {
      console.error('Failed to companies', response);
      return [];
    }

  } catch (error) {
    console.error('Error company data:', url, error);
    return [];
  }
};